import { configureStore } from '@reduxjs/toolkit';
import volunteerPopupReducer from "./PublicPanel/features/volunteerPopupSlice";
import volunteerReducer from "./PublicPanel/features/volunteerSlice";
import authReducer from './AdminPanel/feature/authSlice';
import navbarReducer from "./AdminPanel/feature/navbarSlice.js";
import lookupReducer from "./AdminPanel/feature/lookupSlice.js";
import apiReducer from "./AdminPanel/feature/APISlice.js";
import formReducer from "./AdminPanel/feature/formSlice.js";
import PublicAPIsServiceReducer from "./PublicPanel/features/PublicAPIsService.js";


export const store = configureStore({
  reducer: {
    volunteerPopup: volunteerPopupReducer,
    volunteer: volunteerReducer,
    auth: authReducer,
    navbar: navbarReducer,
    lookups: lookupReducer,
    api: apiReducer,
    form: formReducer,
    PublicAPIsService: PublicAPIsServiceReducer,

  },
});
